<template>
  <div class="plasticAdditive" v-loading="loading">
    <div class="title">产品信息（塑料助剂）</div>
    <el-divider></el-divider>

    <!-- 基本信息 -->
    <div class="companyInformation">
      <div class="content">
        <!-- 左侧表单 -->
        <div class="left">
          <div class="info">
            <!-- <el-form ref="form" :model="form" label-width="80px"> -->
            <el-form label-width="80px" :disabled="disabled">
              <el-form-item label="品名" >
                <el-select
                :disabled="true"
                  v-model="brand"
                  placeholder="请选择品名"
                  ref="brandScroll"
                >
                  <el-option
                    v-for="item in brandOptions"
                    :key="item.value"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="产品信息标题">
                <el-input
                  placeholder="请正确输入产品信息标题"
                  v-model="productTitle"
                  maxlength="25"
                ></el-input>
              </el-form-item>

              <el-form-item label="单价">
                <el-input
                  placeholder="请输入真实价格"
                  v-model="price"
                ></el-input>
                <span class="word">元/公斤</span>
              </el-form-item>
              <el-form-item label="数量">
                <el-input placeholder="请输入数量" v-model="number"></el-input>
                <span class="word">公斤</span>
              </el-form-item>

              <div class="companytype">
                <div class="leftText">是否含税</div>
                <div
                  class="selectItem"
                  v-for="(item, index) in itemList"
                  :key="index"
                  @click="selectTax(index)"
                >
                  <img
                    src="../../assets/bussiness/btn_dl_sel@2x.png"
                    class="checkImage"
                    alt=""
                    v-if="currentIndex == index"
                  />
                  <div class="checkbox" v-else></div>
                  {{ item.name }}
                </div>
              </div>

              <el-form-item label="免费试样">
                <el-input
                  placeholder="不提供试样请输入0"
                  v-model="sample"
                ></el-input>
                <span class="word">公斤</span>
              </el-form-item>

              <el-form-item label="交货地">
                <el-cascader
                  placeholder="请选择交货地"
                  :options="addressList"
                  :props="{ expandTrigger: 'hover', value: 'label' }"
                  @change="handleChange"
                  v-model="handleAddress"
                ></el-cascader>
              </el-form-item>

              <el-form-item label="有效期">
                <el-input
                  placeholder="请输入有效时间：长期/30天/10天"
                  v-model="usefulLife"
                ></el-input>
              </el-form-item>

              <el-form-item label="品牌">
                <el-input placeholder="请输入品牌" v-model="kind"></el-input>
              </el-form-item>

              <el-form-item label="生产商">
                <el-input
                  placeholder="请输入生产商或自产"
                  v-model="producer"
                ></el-input>
              </el-form-item>

              <el-form-item label="型号">
                <el-input
                  placeholder="请输入产品型号"
                  v-model="typeNumber"
                ></el-input>
              </el-form-item>

              <el-form-item label="包装规格">
                <el-input
                  placeholder="请输入包装规格"
                  v-model="size"
                ></el-input>
              </el-form-item>

              <el-form-item label="应用范围">
                <el-select
                  v-model="range"
                  placeholder="请正确选择"
                  :multiple="true"
                  :multiple-limit="2"
                >
                  <el-option
                    v-for="item in rangeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </div>

        <!-- 右侧上传处 -->
        <div class="right">
          <div class="store">
            <div class="leftText">图片</div>
            <div class="uploadPlace">
              <el-upload
                :disabled="disabled"
                :class="{ hide: fifthImage }"
                :action="imgUpload"
                accept="image/*"
                list-type="picture-card"
                :limit="5"
                :on-success="successChange"
                :on-remove="hideLogo"
                :file-list="pictureList"
              >
                <div class="uplogo">
                  <img
                    src="../../assets/bussiness/icon_rzgys_sc@2x.png"
                    alt=""
                    class="image"
                  />
                  <span class="text">请上传</span>
                </div>
              </el-upload>
              <span>（最多上传5张）</span>
            </div>
          </div>

          <div class="video">
            <div class="leftText">视频</div>
            <div class="uploadPlace">
              <el-upload
                :disabled="disabled"
                accept="video/*"
                ref="videoUpload"
                :action="imgUpload"
                list-type="picture-card"
                :multiple="false"
                :show-file-list="false"
                :on-progress="progressProduct"
                :on-success="productSuccess"
                :on-remove="hideproduct"
              >
                <div
                  class="uplogo"
                  v-if="videoUrl == ''"
                  :class="{ hide: videoUrl }"
                >
                  <img
                    src="../../assets/bussiness/icon_rzgys_sc@2x.png"
                    alt=""
                    class="image"
                  />
                  <span class="text">请上传</span>
                </div>
                <img
                  class="closeIcon"
                  src="../../assets/bussiness/gb@3x.png"
                  v-if="videoUrl"
                  alt=""
                  @click.stop="changeVideoUrl"
                />
                <video class="videoBox" :src="videoUrl | urlLoad" v-if="videoUrl"></video>
              </el-upload>
              <span>（只可上传一个，限30S以内）</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      :visible.sync="dialogVisible"
      width="20%"
      class="show-Totast-forever-flex-name"
      >
      <span>您的体验发布次数已用完,需开通优塑会员!</span>
      <span slot="footer" class="dialog-footer">
        <el-button  @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="tzhy()">开通优塑会员</el-button>
      </span>
    </el-dialog>

    <!-- 按钮 -->
    <div v-if="disabled == false">
      <button class="cancelButton button" @click="cancel">取消</button>
      <button class="cancelButton button" @click="submit(0)">保存草稿</button>
      <button class="submitButton button" @click="submit(1)">提交上线</button>
    </div>
  </div>
</template>

<script>
import utils from "../../utils/utils";
import regionJson from "@/json/region";
import bus from "../../utils/bus.js";
import { urlLoad } from '/src/filters/index.js'

export default {
  name: "plasticAdditive",
  props: {
    data1: Object,
    data: Object,
    disabled: Boolean,
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      productTitle: "",
      price: "",
      number: "",
      addressList: [],
      kind: "",
      producer: "",
      typeNumber: "",
      type: "",
      sample: "",
      usefulLife: "",
      size: "25KG",
      brand: "",
      // brandId: "",
      brandOptions: [],
      range: [],
      rangeData: "",
      sjzjOption: [
        { name: "阻燃剂" },
        { name: "增韧剂" },
        { name: "抗氧剂" },
        { name: "增塑剂" },
        { name: "增白剂" },
        { name: "增强剂" },
        { name: "改性剂" },
        { name: "稳定剂" },
        { name: "母粒" },
        { name: "相容剂" },
        { name: "抗静电剂" },
        { name: "润滑剂" },
        { name: "开口剂" },
        { name: "脱模剂" },
        { name: "发泡剂" },
        { name: "清洗剂" },
        { name: "耐磨剂" },
        { name: "增溶剂" },
        { name: "干燥剂" },
        { name: "光亮剂" },
        { name: "消光剂" },
        { name: "分散剂" },

        { name: "着色剂" },
        { name: "荧光增白剂" },
        { name: "除水剂" },
        { name: "添加剂" },
        { name: "促进剂" },
        { name: "防粘连剂" },
        { name: "吸水剂" },
        { name: "填料" },
        { name: "钛白粉" },
        { name: "耐热剂" },
        { name: "聚合物改性剂" },

        { name: "PE蜡" },
        { name: "A蜡" },
        { name: "PP蜡" },
        { name: "PVC粉" },
        { name: "PVC稳定剂" },
        { name: "玻璃纤维" },
        { name: "其他助剂" },
      ],
      rangeOptions: [
        { value: "注塑" },
        { value: "造粒" },
        { value: "吹膜" },
        { value: "片材" },
        { value: "型材" },
        { value: "木塑" },
        { value: "管材" },
        { value: "电缆" },
        { value: "发泡" },
      ],
      pageNo: 1,
      pageSize: 10,
      total: 0,
      productId: 0,
      max: 1,
      handleAddress: [],
      pictureList: [],
      itemList: [{ name: "是" }, { name: "否" }],
      currentIndex: -1,
      userInfo: {},
      draftId: "",
      // 图片
      imgUpload: "https://www.yousubao-01.com/util/file/upload",
      imageList: "",
      imageUrl: "",
      fifthImage: false,
      videoUrl: "",
    };
  },
  watch: {
    data(newData) {
      if (newData) {
        this.changeID();
      }
    },
  },
  created() {
    this.addressList = regionJson;
    this.changeID();
    // this.brandList();
    this.brandOptions = this.sjzjOption;
    let info = JSON.parse(sessionStorage.getItem("userInfo"));
    this.userInfo = info;
  },
  mounted() {
    // this.$refs.brandScroll.$refs.scrollbar.$refs.wrap.addEventListener(
    //   "scroll",
    //   this.brandScolling
    // );
    bus.$on("updateDefaultProvince", (val) => {
      this.handleAddress = val;
    });
    bus.$on("updateDefaultCity", (val) => {
      this.handleAddress = val;
    });
  },

  methods: {
    // 已上线/下线列表不同商品跳转
    changeID() {
      this.loading = false;
      // console.log("塑料助剂this.data1", this.data1);
      // console.log("已上线塑料助剂data", this.data);
      if (this.data1.brandValue) {
        this.brand = this.data1.brandValue;
        console.log("this.brand", this.brand);
        // this.brandId = this.data1.brandId;
        this.handleAddress = [
          this.data1.defaultProvince,
          this.data1.defaultCity,
        ];
        this.type = this.currentIndex = 1;
      } else {
        this.loading = false;
        this.productId = this.data.productId;
        this.draftId = this.data.id;
        this.brand = this.data.productName;
        this.productTitle = this.data.title;
        this.price = this.data.price;
        this.number = this.data.number;
        this.type =
          this.data.taxInclusive == 1
            ? (this.currentIndex = 0)
            : (this.currentIndex = 1); //是否含税
        this.sample = this.data.freeTrialNumber;
        this.handleAddress = [
          this.data.deliverySiteProvince,
          this.data.deliverySiteCity,
        ];
        this.usefulLife = this.data.periodOfValidity;
        this.kind = this.data.markName;
        this.producer = this.data.manufacturersName;
        this.typeNumber = this.data.productModel;
        this.size = this.data.packaging;
        this.level = this.data.productLevel;
        this.type = this.itemList[this.currentIndex].name;
        this.imageList = this.data.imageUrl;
        // 应用范围
        this.range = this.data.productAppliedRange.split(" ");
        var newRange = [];
        for (let i = 0; i < this.range.length; i++) {
          if (this.range[i]) {
            newRange.push(this.range[i]);
          }
        }
        this.range = newRange;

        // 图片
        this.pictureList = this.data.imageUrl.split(",");
        this.pictureList = this.pictureList.map((item) => {
          return {
            name: item,
            url: urlLoad(item),
          };
        });
        // 视频
        this.videoUrl = this.data.videoUrl;
      }
    },
    // 品名列表
    // async brandList() {
    //   let params = {
    //     pageNo: this.pageNo,
    //     pageSize: this.pageSize,
    //   };
    //   if (this.brandSearch) {
    //     params.condition = this.brandSearch;
    //   }
    //   let res = await this.$apiFun.brandList(params);
    //   this.brandOptions.push(...res.result.rows);
    //   this.total = res.result.total;
    //   // console.log("this.brandOptions ", this.brandOptions);
    // },

    // 品名滚动
    // brandScolling() {
    //   let e = this.$refs.brandScroll.$refs.scrollbar.$refs.wrap;
    //   if (this.noMore) return;
    //   // 到底时触发 loadMore
    //   let loadMore = e.scrollHeight - e.scrollTop <= e.clientHeight;
    //   if (loadMore) {
    //     this.pageNo += 1;
    //     this.brandList();
    //   }
    // },

    // 点击是否含税
    selectTax(index) {
      this.currentIndex = index;
      this.type = this.itemList[this.currentIndex].name;
    },

    // 选择交货地
    handleChange(label) {
      this.province = label[0];
      this.city = label[1];
      this.data1.defaultProvince = label[0];
      this.data1.defaultCity = label[1];
      this.data.deliverySiteProvince = label[0];
      this.data.deliverySiteCity = label[1];
    },

    // 图片上传
    successChange(response, file, fileList) {
      var storeList = [];

      // 判断图片长度
      fileList.forEach((item) => {
        var image = "";
        if (item.response) {
          image = item.response.result;
        } else {
          image = item.url;
        }
        storeList.push(image);
      });
      this.imageList = storeList.toString();

      if (fileList.length == 5) {
        this.fifthImage = true;
      }
    },
    hideLogo() {
      setTimeout(() => {
        this.fifthImage = false;
      }, 1000);
    },

    // 产品视频上传
    productSuccess(response, file) {
      this.loading = false;
      this.videoUrl = response.result;
      utils.findvideocover(file.url, file);
    },
    progressProduct() {
      this.loading = true;
    },
    hideproduct() {
      setTimeout(() => {
        this.videoUrl = "";
      }, 900);
    },
    changeVideoUrl() {
      this.videoUrl = "";
    },
    tzhy() {
      this.dialogVisible = false
      this.$router.push("accountEdit");
    },

    // status 0保存 1提交
    async submit(status) {
      console.log("------------",this.brandOptions);
      if (
        // status为1判断是否填写完整
        // 1)发布供应页跳转进来提交
        status == 1 &&
        this.data1.brandValue !== undefined &&
        (this.brand == "" ||
          this.productTitle == "" ||
          this.price == "" ||
          this.number == "" ||
          this.type == "" ||
          this.sample == "" ||
          (this.province == "" && this.city == "") ||
          (this.data1.defaultProvince == undefined &&
            this.data1.defaultCity == undefined) 
          
          // 手机端下面选项可以不填，用户后台同步
          // ||this.usefulLife == "" ||
          // this.kind == "" ||
          // this.producer == "" ||
          // this.typeNumber == "" ||
          // this.size == "" ||
          // this.range == ""
          )
      ) {
        this.$message.error("当前信息填写不完整，请检查并填写完整");
      } else if (
        // 1)发布供应页跳转进来提交
        status == 1 &&
        this.data.productName !== undefined &&
        (this.brand == "" ||
          this.productTitle == "" ||
          this.price == "" ||
          this.number == "" ||
          this.type == "" ||
          this.sample == "" ||
          (this.province == "" && this.city == "") ||
          (this.data.deliverySiteProvince == undefined &&
            this.data.deliverySiteCity == undefined) 

          // 手机端下面选项可以不填，用户后台同步
          // ||this.usefulLife == "" ||
          // this.kind == "" ||
          // this.producer == "" ||
          // this.typeNumber == "" ||
          // this.size == "" ||
          // this.range == ""
          )
      ) {
        this.$message.error("请检查并填写完整信息");
      } else if (status == 1 && this.imageList == "") {
        this.$message.error("请至少上传一张产品图片");
      } else {
        // 应用范围个数
        if (this.range.length == 2) {
          this.rangeData = this.range[0] + " " + this.range[1];
        } else if (this.range.length == 1) {
          this.rangeData = this.range[0];
        }

      
        
        // for (let i = 0; i < this.brandOptions.length; i++) {
        //   if (this.brand == this.brandOptions[i].name) {
        //     this.productId = this.brandOptions[i].id;
        //     break;
        //   }
        // }

        this.productId = this.brandId
        let params = {
          type: "ADJUVANT", //塑料助剂
          productName: this.brand,
          productId: this.productId,
          title: this.productTitle,
          price: this.price,
          number: this.number,
          taxInclusive: this.type == "是" ? 1 : 0,
          freeTrialNumber: this.sample,
          deliverySiteProvince: this.province,
          deliverySiteCity: this.city,
          periodOfValidity: this.usefulLife,
          markName: this.kind,
          manufacturersName: this.producer,
          productModel: this.typeNumber,
          packaging: this.size,
          productAppliedRange: this.rangeData,
          imageUrl: this.imageList,
          hasPc:true,
        };
        params.status = status;
        if (this.videoUrl) {
          params.videoUrl = "";
          params.videoUrl = this.videoUrl;
        } else {
          params.videoUrl = "";
        }

        if (status == 1) {
          //status 1提交
          // 已上线，下线列表跳转
          if (this.data.id) {
            params.id = this.draftId;
            params.memberId = this.userInfo.id;
            let res = await this.$apiFun.saveDraft(params);
            if (res.code == 200) {
              this.$message.success("已发布成功");
              this.successBack();
            }else{
              this.dialogVisible = true
            }
          } else {
            // 发布供应跳转
            let res = await this.$apiFun.releaseSupply(params);
            if (res.code == 200) {
              this.$message.success("已发布成功");
              this.successBack();
            }else{
              this.dialogVisible = true
            }
          }
        } else if (status == 0) {
          //status 0保存
          // 已上线，下线列表跳转
          if (this.data.id) {
            params.id = this.draftId;
            params.memberId = this.userInfo.id;
            let res = await this.$apiFun.saveDraft(params);
            if (res.code == 200) {
              this.$message.success("已保存成功");
              this.successBack();
            }else{
              this.dialogVisible = true
            }
          } else {
            // 发布供应跳转
            let res = await this.$apiFun.releaseSupply(params);
            if (res.code == 200) {
              this.$message.success("已保存成功");
              this.successBack();
            }else{
              this.dialogVisible = true
            }
          }
        }
      }
    },

    // 保存/提交成功后返回上级页面
    successBack() {
      setTimeout(() => {
        this.$emit("backToMain", {
          typeValue: this.data1.typeValue,
          status: this.data.status || "",
        });
      }, 1800);
    },

    cancel() {
      this.$emit("backToMain", {
        typeValue: this.data1.typeValue || "",
        status: this.data.status || "",
      });
    },
  },
};
</script>

<style lang="less" scoped>
	.show-Totast-forever-flex-name {
		font-family: PingFang SC;
		font-size: 28px;
		color: #333333;
		justify-content: center;
	}
.plasticAdditive {
  background: #ffffff;
  box-shadow: 0px 3px 20px 0px rgba(230, 230, 230, 0.8);
  border-radius: 10px;
  padding: 0.3rem 0.5rem;
  font-family: Microsoft YaHei;
  height: 100%;
  .title {
    font-size: 0.24rem;
    font-weight: bold;
    color: #333333;
    line-height: 0.3rem;
    margin-bottom: 0.35rem;
    text-align: left;
  }

  // 基本信息
  .companyInformation {
    text-align: left;
    height: auto;

    .content {
      display: flex;
      // 左侧表单
      .left {
        width: 52%;

        .info {
          border-right: 2px solid #efefef;
          // element表单样式
          /deep/ .el-form {
            .companytype {
              font-size: 0.16rem;
              display: flex;
              align-items: center;
              margin-bottom: 25px;
              .leftText {
                width: 110px;
              }
              .selectItem {
                display: flex;
                cursor: pointer;
                margin-left: 0.3rem;
                justify-content: space-between;

                .checkImage {
                  width: 0.22rem;
                  height: 0.22rem;
                }
                .checkbox {
                  width: 0.2rem;
                  height: 0.2rem;
                  border: 1px solid #999999;
                }
              }
              .selectItem:nth-child(2) {
                margin-left: 0;
              }
            }
            .el-input {
              width: 90%;
            }
            .el-textarea {
              width: 90%;
              height: 4.9rem;
            }
            .el-checkbox__inner {
              width: 0.2rem;
              height: 0.2rem;
              border: 1px solid #999999;
              border-radius: 2px;
              &::after {
                height: 0.12rem;
                left: 0.07rem;
              }
            }
            // 点击样式
            .is-checked {
              .el-checkbox__inner {
                background-color: #f42551;
              }
            }

            .el-form-item__label,
            .el-input__inner,
            .el-textarea__inner,
            .el-checkbox__label {
              font-size: 0.16rem;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #333333;
            }

            .el-input__inner,
            .el-input__count {
              background-color: #f5f5f5;
            }

            .el-textarea__inner {
              height: 100%;
              background-color: #f5f5f5;
            }

            .el-select,
            .el-cascader {
              width: 100%;
              .el-tag.el-tag--info {
                font-size: 0.16rem;
                background: transparent;
                border: none;
                color: #333333;
                .el-tag__close {
                  display: none;
                }
              }
            }

            .el-form-item__label {
              width: 110px !important;
              text-align: left;
            }
            .el-form-item__content {
              margin-left: 110px !important;
              .word {
                position: absolute;
                right: 0.5rem;
                font-size: 0.16rem;
                font-weight: 400;
                color: #333333;
              }
            }
          }
        }
      }

      // 右侧上传处
      .right {
        width: 47%;
        // background: skyblue;
        margin-left: 3%;

        .store,
        .video {
          display: flex;
          justify-content: space-evenly;
          font-size: 0.16rem;
          font-weight: 400;
          margin-bottom: 0.3rem;
          .leftText {
            width: 35%;
            color: #333333;
          }
          .uploadPlace {
            width: 46.9%;
            color: #999999;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            /deep/ .el-upload--picture-card {
              width: 1rem;
              height: 1rem;
              background: #f5f5f5;
              border-radius: 5px;
              cursor: pointer;
              margin-bottom: 0.1rem;
              border: none;
              position: relative;

              .uplogo {
                height: 100%;
                position: relative;
                display: flex;
                justify-content: center;
                flex-direction: column;
                align-items: center;
                .image {
                  height: 0.36rem;
                  width: 0.36rem;
                }
                .text {
                  line-height: 0.3rem;
                }
              }
              .closeIcon {
                position: absolute;
                top: -0.1rem;
                right: -0.1rem;
                z-index: 2;
                width: 0.2rem;
              }
              .videoBox {
                width: 1rem;
                height: 1rem;
                object-fit: fill;
                position: absolute;
                top: 0;
                left: 0;
              }
            }

            .hide /deep/.el-upload--picture-card {
              display: none;
            }

            /deep/ .el-upload-list--picture-card .el-upload-list__item {
              width: 1rem;
              height: 1rem;
            }
          }
        }

        .store {
          // height: 45%;
          height: auto;
        }

        .video {
          .uploadPlace {
            display: flex;
            flex-direction: column;
          }
        }
      }
    }
  }

  // 按钮
  .button {
    width: 1.9rem;
    height: 0.4rem;
    border-radius: 5px;
    font-size: 0.16rem;
    font-weight: bold;
    color: #ffffff;
    line-height: 0.3rem;
    border: 1px solid;
    margin-top: 0.8rem;
    cursor: pointer;
    margin-left: 0.2rem;
  }
  .cancelButton {
    color: #333333;
  }
  .submitButton {
    border: none;
    background: #f42551;
    color: #ffffff;
  }
}
</style>